import type { ListBuilderList } from '../../../types';
import { BASE_FILTER_RULES, TRANSACTION_REQUIRED_FIELDS } from '../shared';

/**
 * Today's transactions list - inherits from all-transactions with date filter for today
 */
export const todaysTransactionsList: ListBuilderList = {
	id: 'default-transaction-todays',
	inheritsFrom: 'default-transaction-all',
	cacheTTL: 300000,
	name: "Today's Transactions",
	type: 'default',
	active: true,
	sortOrder: 3,
	description: 'Transactions from today',
	defaultSortId: 'column-transaction-dates-desc',
	requiredFields: TRANSACTION_REQUIRED_FIELDS,
	filterRules: {
		...BASE_FILTER_RULES,
		paymentDateRange: {
			defaultValue: [
				{
					id: 'today',
					label: 'Today',
					data: {
						startDate: '{{DATE:0d}}',
						endDate: '{{DATE:0d}}',
					},
				},
			],
		},
	},
};
